const actions = {
	GET_DRAG_DROP: 'GET_DRAG_DROP',
	GET_DRAG_DROP_SUCCESS: 'GET_DRAG_DROP_SUCCESS',

	CREATE_NEW_DRAG_DROP: 'CREATE_NEW_DRAG_DROP',
	CREATE_NEW_DRAG_DROP_SUCCESS: 'CREATE_NEW_DRAG_DROP_SUCCESS',

	DELETE_DRAG_DROP: 'DELETE_DRAG_DROP',
	DELETE_DRAG_DROP_SUCCESS: 'DELETE_DRAG_DROP_SUCCESS',

	GET_DRAG_DROP_DETAIL: 'GET_DRAG_DROP_DETAIL',
	GET_DRAG_DROP_DETAIL_SUCCESS: 'GET_DRAG_DROP_DETAIL_SUCCESS',

	UPDATE_DRAG_DROP_DETAIL: 'UPDATE_DRAG_DROP_DETAIL',
	UPDATE_DRAG_DROP_DETAIL_SUCCESS: 'UPDATE_DRAG_DROP_DETAIL_SUCCESS',

	READING_LOADING_FALSE: 'READING_LOADING_FALSE',
	//#region CRUD

	getBlanksDragDrop: (model) => ({
		type: actions.GET_DRAG_DROP,
		payload: { model },
	}),

	getBlanksDragDropDetail: (id) => ({
		type: actions.GET_DRAG_DROP_DETAIL,
		payload: { id },
	}),

	// createQuesReadAloud: (body, cbSuccess, cbError) => ({
	// 	type: actions.CREATE_NEW_DRAG_DROP,
	// 	payload: { body },
	// 	cbSuccess,
	// 	cbError,
	// }),

	// getReadAloudDetail: (id) => ({
	// 	type: actions.GET_DRAG_DROP_DETAIL,
	// 	payload: { id },
	// }),

	// updateReadAloudDetail: (model, cbSuccess, cbError) => ({
	// 	type: actions.UPDATE_DRAG_DROP_DETAIL,
	// 	payload: { model },
	// 	cbSuccess,
	// 	cbError,
	// }),

	// deleteReadAloud: (id, cbSuccess, cbError) => ({
	// 	type: actions.DELETE_DRAG_DROP,
	// 	payload: { id },
	// 	cbSuccess,
	// 	cbError,
	// }),
};

export default actions;
